import { Tab, Tabs } from "@mui/material";
import React from "react";
import styles from "./shared.module.scss";
const CustomNavTabs = ({ selectedTab, handleSelectedTab, navItems, marginBottom = "20px" }) => {
  const handleChange = (event, newValue) => {
    handleSelectedTab(newValue);
  };

  return (
    <div className={styles.tabContainer} style={{ marginBottom }}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        // variant="standard"
        className={styles.indicator}
        TabIndicatorProps={{ style: { display: "none", } }}
      >
        {navItems.map((item, index) => (
          <Tab
            key={index}
            label={item?.label}
            className={selectedTab === index ? styles.selectedTab : styles.tab}
          />
        ))}
      </Tabs>
    </div>
  );
};

export default CustomNavTabs;
